<template>
  <v-row v-if="ready" class="pt-5">
    <v-col cols="10" offset="1">
      <v-row>
        <v-col cols="12">
          <h2>By words</h2>
          <v-select
            :items="dropdownCategories"
            v-model="list"
            @change="changeFilter"
          ></v-select>

          <div ref="iso" id="isoList">
           

            <div
              class="iso-item"
              v-for="card in cloud"
              :key="card.el"
              :style="{ width: card.width }"
            >

              <div class="showcard">
                <div class="showcard__inner">
                  <div class="showcard__inner__text">
                    <h2 :style="{ fontSize: card.size }">
                      {{ card.title }}
                    </h2>
                  </div>
                </div>
                <div class="showcard__count">
                  {{ card.count }}
                </div>
              </div>
            </div>
           
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
import { store } from "@/store.js";
import { Isotope } from "@/vendor";

export default {
  name: "ResultsMessagesWords",
  data() {
    return {
      doc: null,
      intervalId: null,
      dropdownCategories: ["All", "First", "Second", "Third", "Fourth"],
      ready: false,
      list: "All",
      max: 0,
      cloud: [],
      iso: null,
      ignoreList: [
        "we",
        "a",
        "the",
        "&",
        "than",
        "to",
        "their",
        "of",
        "in",
        "and",
        "they",
        "them",
        "as",
        "into",
        "to",
        "we've",
        "we’ve",
        "by",
        "for",
        "i",
        "because",
        "on",
        "off",
        "an",
        "so",
        "are",
        "what",
        "at",
        "has",
        "when",
        "with",
        "can",
        "more",
        "",
        "do",
        "since",
        "is",
        "it's",
        "not",
        "just",
        "its",
        "way",
        "out",
        "have",
        "youll"
      ],
    };
  },
  mounted() {
    this.$nextTick(()=> {
      this.getList();
      this.init();
    })
  },
  computed: {
    ...mapState(["exMessages", "messages"]),
  },
  watch: {
    cloud() {
       this.$nextTick(()=> {
         this.initIso();
         this.layout();
       })
    }
  },
  methods: {
    init() {
      let vm = this;
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.intervalId = setInterval(function() {
        vm.checkStatus();
      }, 300);
    },
    changeFilter(val) {
      this.list = val;
      this.createList();
    },
    checkStatus() {
      console.log('Check status');
      if (this.exMessages && this.messages) {
        this.ready = true;
        clearInterval(this.intervalId);
        this.createList();
        this.initIso();
        this.layout();
      }
    },
    createList() {
      let l;
      switch (this.list) {
        case "All":
          l = this.messages;
          break;
        case "First":
          l = this.exMessages.filter((x) => x.index === 0);
          break;
        case "Second":
          l = this.exMessages.filter((x) => x.index === 1);
          break;
        case "Third":
          l = this.exMessages.filter((x) => x.index === 2);
          break;
        case "Fourth":
          l = this.exMessages.filter((x) => x.index === 3);
          break;
        default:
          l = this.messages;
      }
      const string = this.createStringfromMessages(l);
      const arr = this.createArrayFromString(string)
      this.cloud.length = 0;
      this.cloud = this.setData(arr);
      this.setMax();
      this.applySizes();
    },
    applySizes() {
      this.cloud.map((item) => {
        item.size = this.getFontSize(item.count);
        item.width = this.getWidth(item.count);
      });
    },
    createStringfromMessages(arr) {
      let string = "";
      arr.forEach((item) => {
        string += ` ${item.message.toLowerCase()}`;
      });
      return string;
    },
    createArrayFromString(string) {
      const regex = /[.,()\s]/g;
      const numCheck = /[0-9]/g;
      let originalArr = string.split(" ");
      let arr = [];
      originalArr.forEach((x) => {
        let wordcheck = x.toLowerCase();
        let result = wordcheck.replace(regex, "");
        if (
          !this.ignoreList.some((x) => x == result.trim()) &&
          !result.match(numCheck)
        ) {
          arr.push(result.trim());
        }
      });
      return arr;
    },
    setData(arr) {
      let items = [];
      let distribution = arr.reduce(
        (acum, cur) => Object.assign(acum, { [cur]: (acum[cur] | 0) + 1 }),
        {}
      );
      for (var element in distribution) {
        items.push({ title: element, count: distribution[element] });
      }
      return items;
    },
    setMax() {
      this.max = Math.max.apply(
        null,
        this.cloud.map((item) => item.count)
      );
    },
    getList() {
      let ref = fb.messageContentCollection;
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            store.commit("setMessages", items);
          }
        })
        .catch(function() {});
    },
    initIso() {
      this.iso = null;
      let isoEl = document.getElementById("isoList");
      console.log("init iso");
      this.iso = new Isotope(isoEl, {
        itemSelector: ".iso-item",
        layoutMode: "packery",
        transitionDuration: 0,
        hiddenStyle: {
          opacity: 0,
        },
        visibleStyle: {
          opacity: 1,
        },
      });
    },
    layout() {
      if (this.iso) {
        this.iso.layout();
      }
    },
    getWidth(count) {
      let limit = 50;
      let unit = limit / this.max;
      return `${count * unit}%`;
    },
    getFontSize(count) {
      let limit = 4;
      let unit = limit / this.max;
      return `${count * unit}rem`;
    },
    getPercentage(count) {
      let unit = 100 / this.max;
      return `${count * unit}%`;
    },
  },
};
</script>
